module.exports = __webpack_public_path__ + "components/flag/static/square/dz-557f0818326ccb9058aff981f615f88e.svg";